export const COOKIE_BANNER_CLOSE_BUTTON_DATA_NAME =
  'cookie-message-close-action'
